import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Trainings from "@/pages/Trainings";
import TrainingApplication from "@/pages/TrainingApplication";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { SHOPIER_URL } from "@/lib/contact";

function ShopierRedirect() {
  useEffect(() => { window.location.replace(SHOPIER_URL); }, []);
  return null;
}

function PublicLayout() {
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh]">
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}

function AdminLayout() {
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh]"><Outlet /></main>
      <Footer />
    </>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/egitimler" element={<Trainings />} />
            <Route path="/egitim-basvuru" element={<TrainingApplication />} />
            <Route path="/ekmek-siparisi" element={<ShopierRedirect />} />
            <Route path="/iletisim" element={<Contact />} />
          </Route>
          <Route element={<AdminLayout />}>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
